module.exports = __webpack_public_path__ + "img/ABUIABAEGAAg5oGL9AUox9PE2wUw8Ac4zQY.32601e20.png";